import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../shared/utils/error';
import PartesScreen from './screen';
import { PartesAdapter, Parte, FiltroPartes } from '../../../../infraestructure/persistence/rest/PartesAdapter';
import { useNotifications } from '../../../../shared/hooks/Notifications';
import { UsuariosAdapter } from '../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useUserSettings } from '../../context/CurrentUserContext';

const PartesContainer = (props:any) => {

	const {currentSettingsApp} = props
	const api = new PartesAdapter();
	const apiUser = new UsuariosAdapter();
	const pantalla = 'partes';
	const {resultError, exceptionError, launchNotification} = useNotifications();
	const {currentUser} = useUserSettings();
	let [ partes, setPartes ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState(false)
	let result: any;

	useEffect(() => {setIsLoading(false)}, [ partes ]);

	const getColumnConfig =async (dni?:string) =>{
		try {
			result = await apiUser.GetColumnasUsuario(dni);
			if(result.data && result.data!=="")
			{
			  const columnas = result.data[0] && JSON.parse(result.data[0].columnas).pantallas.filter((f:any)=> f.pantalla === pantalla)[0]
			  return columnas || undefined
			}else{resultError()}
		  } catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		  }
	}

	const getPartes = async (filtro: FiltroPartes ) => {
		try {
			result = await api.ListarPartes(filtro);
			if(result.data && result.data!=="")
			{
				setPartes([ ...result.data ]);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createParte = async (parte: any, isWeekEnd:boolean, adjuntos:any) => {
		try {
			setIsLoading(true)
			result =  isWeekEnd===true ? await api.CrearParteFinSemana(parte) : await api.CrearParte(parte);
			if(result.data && result.data!=="")
			{
				if(adjuntos){
					let adj = await adjuntarFicheros(adjuntos, result.data)
					if(adj)
					{
						adjuntar(result.data,true)
						launchNotification({type:"success",title:"Creación",message:"Se ha creado un nuevo parte."})
					}else{
						//setPartes([ ...partes,...result.data ]);
						await deletePartes(result.data.map((d:Parte)=> d.idParte), true)
						launchNotification({type:"error",title:"Adjuntar",message:"Se ha producido un error al adjuntar los archivos."},false)
						setIsLoading(false)
					}
				}else{
					setPartes([ ...partes,...result.data ]);
					launchNotification({type:"success",title:"Creación",message:"Se ha creado un nuevo parte."})
				}
				
			}else{resultError();setIsLoading(false)}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	const deleteAction = async (partes: any) => {
		const hayFacturados = partes.filter((p:Parte) => p.facturado===true).length>0;
		const hayValidados = partes.filter((p:Parte)=> p.estado>1 && p.estado<5).length>0;
		
		if(hayFacturados===true)
		{launchNotification({type:"warning",title:"Eliminación",message:"No se pueden eliminar partes facturados."})}
		else{
			if(hayValidados===true){
				{launchNotification({type:"warning",title:"Eliminación",message:"No se pueden eliminar partes validados."})}
			}else{
			let ids = partes.map((p:Parte) => p.idParte);
			ids.length > 1 ? deletePartes(ids) : deleteParte(ids[0]);
			}
		}
	}

	const deleteParte = async (idParte: number) => {
		try {
			setIsLoading(true)
			result = await api.EliminarParte(idParte);
			if(result.data && result.data!=="")
			{
				let pos = partes.findIndex((f: Parte) => f.idParte === idParte);
				let newData = [ ...partes ];
				newData.splice(pos, 1);
				setPartes([ ...newData ]);
				setIsLoading(false);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado un parte."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false);
		}
	};

	const deletePartes = async (ids: any, isForced:boolean=false) => {
		try {
			// if(!isForced){setIsLoading(true)}
			setIsLoading(true)
			result = await api.EliminarPartes(ids);
			if(result.data && result.data!=="" )
			{
				// if(!isForced)
				// {
					let pos=0;
					let newData:any=[...partes ];
			
					ids.forEach((i:number)=>{
						pos = newData.findIndex((f: Parte) => f.idParte === i);
						newData.splice(pos, 1);
					})
					setPartes([ ...newData ]);
					setIsLoading(false)
					launchNotification({type:"success",title:"Eliminación Múltiple",message:"Se han eliminado los partes."})
				//}
			}else{resultError();setIsLoading(false)}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	const updateParte = async (parte: Parte, isWeekEnd:boolean) => {
		try {
			result = isWeekEnd === false ? await api.ModificarParte(parte) : await api.ModificarParteFinSemana(parte);
			if(result.data && result.data!=="")
			{
				let pos = partes.findIndex((f: Parte) => f.idParte === parte.idParte);
				let newData = [ ...partes ];
				newData[pos] = result.data[0];
				setPartes([ ...newData ]);
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un parte."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const adjuntarFicheros = async (adjuntos: any,newPartes:any) => {
		if(adjuntos)
		{
			const ids = newPartes.map((np:Parte) => np.idParte)
			try {
				let resultAdj = await api.AdjuntarFicheros({ IdsPartes: ids, adjuntos:adjuntos});
				if(resultAdj.data && resultAdj.data!=="")
				{
					return resultAdj.data;
				}else{resultError(); return false}
			} catch (e) {
				if(!newPartes){
				let exception = ServerErrorMessage(e);
				exceptionError(exception);
				}
				return false
			}
		}else{return true}
  	};

	const adjuntar = (selected:any, isNew:boolean=false) =>{
		
		if(!isNew){
			let newData:any = [...partes];
			selected.forEach((parte:Parte)=>{
				let changes = {tieneAdjuntos:true}
				let pos = partes.findIndex((f: Parte) => f.idParte === parte.idParte);
				newData[pos] = {...newData[pos],...changes};
			})
			setPartes([ ...newData ]);
		}else{
			selected.forEach((parte:Parte)=>{parte.tieneAdjuntos=true})
			setPartes([ ...partes,...selected ]);
		}
		
	}
	
	return (<PartesScreen
	data={partes}
	handleCreate={createParte}
	handleRemove={deleteAction}
	handleUpdate={updateParte}
	handleFilter={getPartes}
	handleAdjuntar={adjuntar}
	getColumns={getColumnConfig}
	isLoading={isLoading}
	currentSettingsApp={currentSettingsApp}
	/>)
};

export default PartesContainer;
